//import mapStyle from './map-styles.json';

var map;

function initMap() {
  var mapEl = document.getElementById('map');

  if ( mapEl ) {
    var center = {
      lat: parseFloat(mapEl.getAttribute('data-lat')),
      lng: parseFloat(mapEl.getAttribute('data-lng'))
    };

    map = new google.maps.Map(mapEl, {
      center: center,
      zoom: parseInt(mapEl.getAttribute('data-zoom')),
      //styles: mapStyle,
      scrollwheel: false,
    });

    var image = '/images/pin.png';

    var marker = new google.maps.Marker({
      position: center,
      map: map,
      title: mapEl.getAttribute('data-title'),
      icon: image,
    });
  }
}

initMap();



// WEBPACK FOOTER //
// ./scripts/components/map.js